import React, { createContext, useState, useContext, useRef } from 'react';
import authService from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(authService.getCurrentUser());
  const tokenRef = useRef(user?.token || null);

  const login = async (username, password) => {
    const data = await authService.login(username, password);
    setUser(data);
    tokenRef.current = data?.token || null;
    return data;
  };

  const register = async (firstName, lastName, username, email, password) => {
    const data = await authService.register(firstName, lastName, username, email, password);
    setUser(data);
    tokenRef.current = data?.token || null;
    return data;
  };

  const logout = () => {
    authService.logout();
    setUser(null);
    tokenRef.current = null;
  };

  const getToken = () => tokenRef.current;

  return (
    <AuthContext.Provider value={{ user, login, register, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);